import { Portal } from "@/models/Portal";
import * as importConfig from "../utils/import-config";

const devMode = typeof window === "undefined" || (window && window.location.href.indexOf("localhost") !== -1);

const productionMode = !devMode;
const debugMode = false;
const v = "125";

// When running vue cli serve, target portal is set from build config
declare const targetSite: string | undefined;
declare const useNewContentNodes: boolean;

export class Config {
  public readonly version = v;
  public readonly debug = debugMode;
  public readonly production = productionMode;
  public readonly portal!: Portal;
  
  public constructor() {
    if (targetSite !== undefined) {
      this.portal = targetSite === "vcc" ? Portal.Vcc : Portal.Polestar;
    } else {
      this.portal = window.location.href.indexOf("vcc") > -1 ? Portal.Vcc : Portal.Polestar;
    }
  }

  public readonly breakpoints: any = {
    desktop: 992,
    tablet: 768,
    mobile: 480,
  };

  public readonly defaultImageWidth = 1000;

  public readonly devServer: ServerInfo = {
    host: "localhost",
    port: 8080,
  };

  public readonly umbracoDevServer: PortalHostInfo = {
    vcc: {
      host: "https://vcctrip.local",
      hostName: "vcctrip.local",
    },
    polestar: {
      host: "https://local.trip.polestar.com",
      hostName: "local.trip.polestar.com",
    },
  };

  public readonly appName: PortalInfo = {
    vcc: "VCC-TRIP",
    polestar: "Polestar-TRIP",
  };

  public getDataPath(portal: Portal, platform: string) {
    return importConfig.getImportPath(portal, platform);
  };
  
  public getPortalDataPath(portal: Portal) { 
    return importConfig.getPortalImportPath(portal); 
  }

  public get useNewContentNodes(): boolean { return useNewContentNodes; }
  public get htmlDirname() { return importConfig.htmlDirname; }
  public get nodesFilename() { return importConfig.nodesFilename; }
  public get topicsFilename() { return importConfig.topicsFilename; }
  public get releaseNotesFilename() { return importConfig.releaseNotesFilename; }
  
  public readonly searchMinChars = 1;
  public readonly searchDebounceTime = 350;
  public readonly searchHistoryMaxItem = 10;
  public readonly searchParamName = "search";
  public readonly processTime = 350; // Fake process time
  public readonly releaseNotesPlatform = "spa_cma";
  
  public topicBasketLimit = 50; // Max number of topics in Document Basket

  public newsDeactivatedFor = ["16w24", "16w46", "17w17", "17w46", "17w18", "18w17", "18w35", "18w46"];
}

interface PortalInfo {
  vcc: string;
  polestar: string;
}

interface PortalHostInfo {
  vcc: ServerInfo;
  polestar: ServerInfo;
}

interface ServerInfo {
  host: string;
  hostName?: string;
  port?: number;
}